import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';

const BaseUrl = process.env.REACT_APP_Sabzi_BASE;

function QuestionsCrud() {
  const { login , logout ,apiBaseUrl } = useAuth();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedId, setExpandedId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAnswerEditModal, setShowAnswerEditModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [editFormData, setEditFormData] = useState({
    question: '',
    points: '',
    duration: ''
  });
  const [answerFormData, setAnswerFormData] = useState({
    answer: '',
    is_correct: false,
    question_id: null
  });
  const [updatingAnswerId, setUpdatingAnswerId] = useState(null);



  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createFormData, setCreateFormData] = useState({
  challenge_id: 1,
  question: '',
  points: 5,
  order: 1,
  duration: 3000
});


const [showCreateAnswerModal, setShowCreateAnswerModal] = useState(false);
const [createAnswerFormData, setCreateAnswerFormData] = useState({
  question_id: null,
  answer: '',
  is_correct: false
});

const [showDeleteAnswerModal, setShowDeleteAnswerModal] = useState(false);
const [selectedAnswerToDelete, setSelectedAnswerToDelete] = useState(null);



  useEffect(() => {
    fetchQuestions();
  }, []);

  const handleAnswerDeleteClick = (e, answer) => {
  e.stopPropagation();
  setSelectedAnswerToDelete(answer);
  setShowDeleteAnswerModal(true);
};

const handleAnswerDeleteConfirm = async () => {
  try {
    await axios.delete(`${apiBaseUrl}/api/quiz/admin/answers/${selectedAnswerToDelete.id}`);
    await fetchQuestions();
    setShowDeleteAnswerModal(false);
    setSelectedAnswerToDelete(null);
  } catch (err) {
    console.error('Khata dar hazfe javab:', err);
    setError('Khata dar hazfe javab');
  }
};

  const handleCreateAnswerClick = (e, questionId) => {
  e.stopPropagation();
  setCreateAnswerFormData({
    question_id: questionId,
    answer: '',
    is_correct: false
  });
  setShowCreateAnswerModal(true);
};

const handleCreateAnswerSubmit = async () => {
  try {
    const payload = {
      question_id: createAnswerFormData.question_id,
      answer: createAnswerFormData.answer,
      is_correct: createAnswerFormData.is_correct
    };

    await axios.post(`${apiBaseUrl}/api/quiz/admin/answers`, payload);
    await fetchQuestions();
    setShowCreateAnswerModal(false);
    setCreateAnswerFormData({
      question_id: null,
      answer: '',
      is_correct: false
    });
  } catch (err) {
    console.error('Khata dar sakhte javab:', err);
    setError('Khata dar sakhte javabe jadid');
  }
};


  const handleCreateSubmit = async () => {
  try {
    const payload = {
      challenge_id: parseInt(createFormData.challenge_id),
      question: createFormData.question,
      points: parseInt(createFormData.points),
      order: parseInt(createFormData.order),
      duration: parseInt(createFormData.duration)
    };

    await axios.post(`${apiBaseUrl}/api/quiz/admin/questions`, payload);
    await fetchQuestions();
    setShowCreateModal(false);
    setCreateFormData({
      challenge_id: 1,
      question: '',
      points: 5,
      order: 1,
      duration: 3000
    });
  } catch (err) {
    console.error('Khata dar sakhte soal:', err);
    setError('Khata dar sakhte soale jadid');
  }
};

  const fetchQuestions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${apiBaseUrl}/api/quiz/admin/questions`);
      console.log(response)
      setQuestions(response.data.data || []);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Daryafte soalat ba moshkel movajeh shod');
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (questionId) => {
    setExpandedId(expandedId === questionId ? null : questionId);
  };

  const handleEditClick = (e, question) => {
    e.stopPropagation();
    setSelectedQuestion(question);
    setEditFormData({
      question: question.question,
      points: question.points,
      duration: question.duration
    });
    setShowEditModal(true);
  };

  const handleDeleteClick = (e, question) => {
    e.stopPropagation();
    setSelectedQuestion(question);
    setShowDeleteModal(true);
  };

  const handleAnswerEditClick = (e, answer, questionId) => {
    e.stopPropagation();
    setSelectedAnswer(answer);
    setAnswerFormData({
      answer: answer.answer,
      is_correct: answer.is_correct,
      question_id: questionId
    });
    setShowAnswerEditModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await axios.delete(`${apiBaseUrl}/api/quiz/admin/questions/${selectedQuestion.id}`);
      setQuestions(questions.filter(q => q.id !== selectedQuestion.id));
      setShowDeleteModal(false);
      setSelectedQuestion(null);
    } catch (err) {
      console.error('Khata dar hazf:', err);
      setError('Khata dar hazfe soal');
    }
  };

  const handleEditSubmit = async () => {
    try {
      const payload = {
        question: editFormData.question,
        points: parseInt(editFormData.points),
        duration: parseInt(editFormData.duration)
      };

      await axios.put(`${apiBaseUrl}/api/quiz/admin/questions/${selectedQuestion.id}`, payload);
      await fetchQuestions();
      setShowEditModal(false);
      setSelectedQuestion(null);
    } catch (err) {
      console.error('Khata dar virayesh:', err);
      setError('Khata dar virayeshe soal');
    }
  };

  const handleAnswerUpdate = async () => {
    try {
      setUpdatingAnswerId(selectedAnswer.id);
      
      const payload = {
        question_id: answerFormData.question_id,
        answer: answerFormData.answer,
        is_correct: answerFormData.is_correct
      };

      await axios.put(`${apiBaseUrl}/api/quiz/admin/answers/${selectedAnswer.id}`, payload);
      await fetchQuestions();
      setShowAnswerEditModal(false);
      setSelectedAnswer(null);
      setUpdatingAnswerId(null);
    } catch (err) {
      console.error('Khata dar update javab:', err);
      setError('Khata dar update javab');
      setUpdatingAnswerId(null);
    }
  };

  if (loading) {
    return (
      <div className="p-8 h-full flex items-center justify-center" style={{ backgroundColor: '#111827' }}>
        <div className="text-center">
          <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center animate-spin" style={{ backgroundColor: '#fd0d0e' }}>
            <div className="w-12 h-12 rounded-full" style={{ backgroundColor: '#1f2937' }}></div>
          </div>
          <p className="text-gray-300">در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6" style={{ backgroundColor: '#111827' }}>
      <div className="max-w-7xl mx-auto">
       <div className="mb-6 flex justify-between items-center">
  <h1 className="text-3xl font-bold text-white">مدیریت سوالات</h1>
  <div className="flex gap-3">
    <button
      onClick={() => setShowCreateModal(true)}
      className="rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105 flex items-center gap-2"
      style={{ backgroundColor: '#10b981', color: 'white' }}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
      سوال جدید
    </button>
    <button
      onClick={fetchQuestions}
      className="rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105 flex items-center gap-2"
      style={{ backgroundColor: '#fd0d0e', color: 'white' }}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
      بارگذاری مجدد
    </button>
  </div>
</div>

        {error && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-6 rounded-xl p-4 border border-red-500"
            style={{ backgroundColor: '#7f1d1d' }}
          >
            <p className="text-red-200">خطا: {error}</p>
          </motion.div>
        )}

        {questions.length === 0 && !loading && (
          <div className="text-center py-12 rounded-xl border border-gray-600" style={{ backgroundColor: '#1f2937' }}>
            <p className="text-gray-400 text-lg">هیچ سوالی وجود ندارد</p>
          </div>
        )}

        {questions.length > 0 && (
          <div className="space-y-3">
            {questions.map((question, index) => (
              <motion.div
                key={question.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
              >
                <div
                  onClick={() => handleRowClick(question.id)}
                  className="rounded-xl border transition-all duration-200 hover:border-gray-500 cursor-pointer overflow-hidden"
                  style={{ 
                    backgroundColor: '#1f2937',
                    borderColor: question.answers?.some(a => a.is_correct) ? '#10b981' : '#4b5563',
                    borderWidth: question.answers?.some(a => a.is_correct) ? '2px' : '1px'
                  }}
                >
                  <div className="p-4 flex items-center justify-between">
                    <div className="flex items-center gap-4 flex-1">
                      <div
                        className="w-12 h-12 rounded-lg flex items-center justify-center font-bold text-white"
                        style={{ backgroundColor: '#fd0d0e' }}
                      >
                        {question.id}
                      </div>
                      <div className="flex-1">
                        <p className="text-white font-medium text-lg mb-1">{question.question}</p>
                        <div className="flex gap-4 text-sm text-gray-400">
                          <span>امتیاز: {question.points}</span>
                          <span>زمان: {question.duration}s</span>
                          <span>تعداد جواب: {question.answers?.length || 0}</span>
                          {question.answers?.some(a => a.is_correct) && (
                            <span className="text-green-400 font-medium">✓ دارای پاسخ صحیح</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        onClick={(e) => handleEditClick(e, question)}
                        className="rounded-lg px-4 py-2 font-medium transition-all duration-200 hover:scale-105"
                        style={{ backgroundColor: '#374151', color: 'white' }}
                      >
                        ویرایش
                      </button>
                      <button
                        onClick={(e) => handleDeleteClick(e, question)}
                        className="rounded-lg px-4 py-2 font-medium transition-all duration-200 hover:scale-105"
                        style={{ backgroundColor: '#7f1d1d', color: 'white' }}
                      >
                        حذف
                      </button>
                      <motion.div
                        animate={{ rotate: expandedId === question.id ? 180 : 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </motion.div>
                    </div>
                  </div>

                  <AnimatePresence>
                    {expandedId === question.id && (
                      <motion.div
  initial={{ height: 0, opacity: 0 }}
  animate={{ height: 'auto', opacity: 1 }}
  exit={{ height: 0, opacity: 0 }}
  transition={{ duration: 0.3 }}
  className="border-t border-gray-600"
  style={{ backgroundColor: '#111827' }}
>
  <div className="p-4">
    <div className="flex justify-between items-center mb-3">
      <h4 className="text-white font-medium">جواب‌های سوال:</h4>
      <button
        onClick={(e) => handleCreateAnswerClick(e, question.id)}
        className="rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 hover:scale-105 flex items-center gap-2"
        style={{ backgroundColor: '#10b981', color: 'white' }}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        گزینه جدید
      </button>
    </div>
    {question.answers && question.answers.length > 0 ? (
      <div className="grid grid-cols-1 gap-3">
        {question.answers.map((answer, idx) => (
          <div
            key={answer.id}
            className="rounded-lg p-3 border-2 transition-all duration-200"
            style={{ 
              backgroundColor: answer.is_correct ? '#065f46' : '#1f2937',
              borderColor: answer.is_correct ? '#10b981' : '#374151'
            }}
          >
          <div className="flex items-center justify-between gap-3">
  <div className="flex items-center gap-3 flex-1">
    <div
      className="w-8 h-8 rounded-lg flex items-center justify-center font-bold text-white flex-shrink-0"
      style={{ backgroundColor: answer.is_correct ? '#10b981' : '#374151' }}
    >
      {answer.is_correct ? (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      ) : (
        ['الف', 'ب', 'ج', 'د'][idx]
      )}
    </div>
    <p className="text-gray-300 text-sm flex-1">{answer.answer}</p>
    {answer.is_correct && (
      <span className="text-xs text-green-300 font-medium">صحیح</span>
    )}
  </div>
  <div className="flex items-center gap-2">
    <button
      onClick={(e) => handleAnswerEditClick(e, answer, question.id)}
      className="rounded-lg px-3 py-1.5 text-sm font-medium transition-all duration-200 hover:scale-105 flex-shrink-0"
      style={{ backgroundColor: '#374151', color: 'white' }}
      disabled={updatingAnswerId === answer.id}
    >
      {updatingAnswerId === answer.id ? 'در حال بروزرسانی...' : 'ویرایش'}
    </button>
    <button
      onClick={(e) => handleAnswerDeleteClick(e, answer)}
      className="rounded-lg px-3 py-1.5 text-sm font-medium transition-all duration-200 hover:scale-105 flex-shrink-0"
      style={{ backgroundColor: '#7f1d1d', color: 'white' }}
    >
      حذف
    </button>
  </div>
</div>
          </div>
        ))}
      </div>
    ) : (
      <p className="text-gray-400 text-sm">هیچ جوابی ثبت نشده است</p>
    )}
  </div>
</motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>

      {/* Create Question Modal */}
<AnimatePresence>
  {showCreateModal && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 flex items-center justify-center p-4 z-50"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
      onClick={() => setShowCreateModal(false)}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="rounded-xl border border-gray-600 p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto"
        style={{ backgroundColor: '#1f2937' }}
      >
        <h2 className="text-2xl font-bold text-white mb-6">ایجاد سوال جدید</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-gray-300 mb-2 font-medium">متن سوال:</label>
            <input
              type="text"
              value={createFormData.question}
              onChange={(e) => setCreateFormData({...createFormData, question: e.target.value})}
              placeholder="سوال خود را وارد کنید"
              className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
              style={{ backgroundColor: '#111827' }}
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-300 mb-2 font-medium">Challenge ID:</label>
              <input
                type="number"
                value={createFormData.challenge_id}
                onChange={(e) => setCreateFormData({...createFormData, challenge_id: e.target.value})}
                className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                style={{ backgroundColor: '#111827' }}
              />
            </div>
            
            <div>
              <label className="block text-gray-300 mb-2 font-medium">امتیاز:</label>
              <input
                type="number"
                value={createFormData.points}
                onChange={(e) => setCreateFormData({...createFormData, points: e.target.value})}
                className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                style={{ backgroundColor: '#111827' }}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-300 mb-2 font-medium">ترتیب:</label>
              <input
                type="number"
                value={createFormData.order}
                onChange={(e) => setCreateFormData({...createFormData, order: e.target.value})}
                className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                style={{ backgroundColor: '#111827' }}
              />
            </div>
            
            <div>
              <label className="block text-gray-300 mb-2 font-medium">زمان (میلی‌ثانیه):</label>
              <input
                type="number"
                value={createFormData.duration}
                onChange={(e) => setCreateFormData({...createFormData, duration: e.target.value})}
                className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                style={{ backgroundColor: '#111827' }}
              />
            </div>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={handleCreateSubmit}
            className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: '#10b981', color: 'white' }}
          >
            ایجاد سوال
          </button>
          <button
            onClick={() => setShowCreateModal(false)}
            className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: '#374151', color: 'white' }}
          >
            انصراف
          </button>
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

      {/* Edit Question Modal */}
      <AnimatePresence>
        {showEditModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 flex items-center justify-center p-4 z-50"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
            onClick={() => setShowEditModal(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="rounded-xl border border-gray-600 p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto"
              style={{ backgroundColor: '#1f2937' }}
            >
              <h2 className="text-2xl font-bold text-white mb-6">ویرایش سوال</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-gray-300 mb-2 font-medium">سوال:</label>
                  <input
                    type="text"
                    value={editFormData.question}
                    onChange={(e) => setEditFormData({...editFormData, question: e.target.value})}
                    className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                    style={{ backgroundColor: '#111827' }}
                  />
                </div>
                
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-300 mb-2 font-medium">امتیاز:</label>
                    <input
                      type="number"
                      value={editFormData.points}
                      onChange={(e) => setEditFormData({...editFormData, points: e.target.value})}
                      className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                      style={{ backgroundColor: '#111827' }}
                    />
                  </div>
                  
                  <div>
                    <label className="block text-gray-300 mb-2 font-medium">زمان (ثانیه):</label>
                    <input
                      type="number"
                      value={editFormData.duration}
                      onChange={(e) => setEditFormData({...editFormData, duration: e.target.value})}
                      className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                      style={{ backgroundColor: '#111827' }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={handleEditSubmit}
                  className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
                  style={{ backgroundColor: '#fd0d0e', color: 'white' }}
                >
                  ذخیره تغییرات
                </button>
                <button
                  onClick={() => setShowEditModal(false)}
                  className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
                  style={{ backgroundColor: '#374151', color: 'white' }}
                >
                  انصراف
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Edit Answer Modal */}
      <AnimatePresence>
        {showAnswerEditModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 flex items-center justify-center p-4 z-50"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
            onClick={() => setShowAnswerEditModal(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="rounded-xl border border-gray-600 p-6 max-w-lg w-full"
              style={{ backgroundColor: '#1f2937' }}
            >
              <h2 className="text-2xl font-bold text-white mb-6">ویرایش جواب</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-gray-300 mb-2 font-medium">متن جواب:</label>
                  <input
                    type="text"
                    value={answerFormData.answer}
                    onChange={(e) => setAnswerFormData({...answerFormData, answer: e.target.value})}
                    className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
                    style={{ backgroundColor: '#111827' }}
                  />
                </div>
                
                <div className="rounded-lg p-4 border border-gray-600" style={{ backgroundColor: '#111827' }}>
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={answerFormData.is_correct}
                      onChange={(e) => setAnswerFormData({...answerFormData, is_correct: e.target.checked})}
                      className="w-5 h-5 accent-green-500"
                    />
                    <span className="text-gray-300 font-medium">این جواب صحیح است</span>
                  </label>
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={handleAnswerUpdate}
                  disabled={updatingAnswerId !== null}
                  className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ backgroundColor: '#fd0d0e', color: 'white' }}
                >
                  {updatingAnswerId !== null ? 'در حال ذخیره...' : 'ذخیره تغییرات'}
                </button>
                <button
                  onClick={() => setShowAnswerEditModal(false)}
                  disabled={updatingAnswerId !== null}
                  className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                  style={{ backgroundColor: '#374151', color: 'white' }}
                >
                  انصراف
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>


      {/* Create Answer Modal */}
<AnimatePresence>
  {showCreateAnswerModal && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 flex items-center justify-center p-4 z-50"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
      onClick={() => setShowCreateAnswerModal(false)}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="rounded-xl border border-gray-600 p-6 max-w-lg w-full"
        style={{ backgroundColor: '#1f2937' }}
      >
        <h2 className="text-2xl font-bold text-white mb-6">ایجاد گزینه جدید</h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-gray-300 mb-2 font-medium">متن گزینه:</label>
            <input
              type="text"
              value={createAnswerFormData.answer}
              onChange={(e) => setCreateAnswerFormData({...createAnswerFormData, answer: e.target.value})}
              placeholder="گزینه خود را وارد کنید"
              className="w-full rounded-lg px-4 py-3 border border-gray-600 text-white focus:outline-none focus:border-gray-400"
              style={{ backgroundColor: '#111827' }}
            />
          </div>
          
          <div className="rounded-lg p-4 border border-gray-600" style={{ backgroundColor: '#111827' }}>
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={createAnswerFormData.is_correct}
                onChange={(e) => setCreateAnswerFormData({...createAnswerFormData, is_correct: e.target.checked})}
                className="w-5 h-5 accent-green-500"
              />
              <span className="text-gray-300 font-medium">این گزینه پاسخ صحیح است</span>
            </label>
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button
            onClick={handleCreateAnswerSubmit}
            className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: '#10b981', color: 'white' }}
          >
            ایجاد گزینه
          </button>
          <button
            onClick={() => setShowCreateAnswerModal(false)}
            className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: '#374151', color: 'white' }}
          >
            انصراف
          </button>
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

{/* Delete Answer Confirmation Modal */}
<AnimatePresence>
  {showDeleteAnswerModal && (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 flex items-center justify-center p-4 z-50"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
      onClick={() => setShowDeleteAnswerModal(false)}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="rounded-xl border border-red-500 p-6 max-w-md w-full"
        style={{ backgroundColor: '#1f2937' }}
      >
        <div className="text-center mb-6">
          <div
            className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
            style={{ backgroundColor: '#7f1d1d' }}
          >
            <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h3 className="text-xl font-bold text-white mb-2">آیا مطمئن هستید؟</h3>
          <p className="text-gray-300 mb-2">این گزینه برای همیشه حذف خواهد شد</p>
          {selectedAnswerToDelete && (
            <p className="text-gray-400 text-sm mt-2 p-3 rounded-lg" style={{ backgroundColor: '#111827' }}>
              "{selectedAnswerToDelete.answer}"
            </p>
          )}
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleAnswerDeleteConfirm}
            className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: '#7f1d1d', color: 'white' }}
          >
            بله، حذف شود
          </button>
          <button
            onClick={() => setShowDeleteAnswerModal(false)}
            className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: '#374151', color: 'white' }}
          >
            انصراف
          </button>
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

      {/* Delete Confirmation Modal */}
      <AnimatePresence>
        {showDeleteModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 flex items-center justify-center p-4 z-50"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.75)' }}
            onClick={() => setShowDeleteModal(false)}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
              className="rounded-xl border border-red-500 p-6 max-w-md w-full"
              style={{ backgroundColor: '#1f2937' }}
            >
              <div className="text-center mb-6">
                <div
                  className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center"
                  style={{ backgroundColor: '#7f1d1d' }}
                >
                  <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">آیا مطمئن هستید؟</h3>
                <p className="text-gray-300">این سوال برای همیشه حذف خواهد شد</p>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={handleDeleteConfirm}
                  className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
                  style={{ backgroundColor: '#7f1d1d', color: 'white' }}
                >
                  بله، حذف شود
                </button>
                <button
                  onClick={() => setShowDeleteModal(false)}
                  className="flex-1 rounded-lg px-6 py-3 font-medium transition-all duration-200 hover:scale-105"
                  style={{ backgroundColor: '#374151', color: 'white' }}
                >
                  انصراف
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default QuestionsCrud;